import { useAppDispatch } from "@/app/store/hooks";
import type { ProjectPresentationType } from "@/entities/projects/model/types";
import { FeedbackForm } from "@/features/feedbacks/ui/FeedbackForm";
import { Image } from "@/shared/ui/img/Image";
import { SectionLayout } from "@/shared/ui/layouts/SectionLayout";
import Typography from "@/shared/ui/Typography";
import { complatedModalOpen } from "@/widgets/modal/model/slice";

export interface IGetPresentationSectionProps {
    imageUrl: string | null;
    presentation: ProjectPresentationType;
}

export function GetPresentationSection({
    presentation,
    imageUrl,
}: IGetPresentationSectionProps) {

    const dispatch = useAppDispatch()
    
        const handleDownloadPresentation = (name: string, phone: string) => {
    
            // send data logic
            console.log(name, phone);
    
            const link = document.createElement("a");
            link.href = presentation.link;
            link.download = "";
            link.target = "_blank";
            link.rel = "noopener noreferrer";
    
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            dispatch(complatedModalOpen(presentation.link))
    
        }

    return (
        <SectionLayout
            className=""
            containerClassName="pt-[20px] pb-[40px] md:py-[40px]"
        >
            <div className="py-[20px] px-[16px] md:p-[32px] lg:p-[40px] flex flex-col gap-[20px] lg:gap-[32px] bg-light-blue rounded-[10px]">
                <div className="flex flex-col md:flex-row gap-[20px] lg:gap-[32px]">
                    
                    <div className="w-full relative h-[193px] md:h-[inherit] md:w-[310px] lg:w-[450px] rounded-[10px] overflow-hidden object-cover object-center">
                        <Image
                            className="absolute w-full h-full object-cover"
                            src={imageUrl || "/images/defaults/card.png"}
                            fallbackSrc="/images/defaults/card.png"
                            alt=""
                        />
                    </div>

                    <div className="flex flex-col md:flex-1 gap-[16px] md:gap-[28px] lg:gap-[32px]">
                        <Typography tag="h2" className="md:!leading-[130%]">
                            {presentation.title}
                        </Typography>

                        <Typography className="uppercase text-[14px] md:text-[16px] font-normal !leading-[120%]">
                            {presentation.description}
                        </Typography>
                    </div>
                </div>

                <FeedbackForm 
                    download={true} 
                    onSubmit={handleDownloadPresentation}
                />
            </div>
        </SectionLayout>
    );
}
